import type { ReactNode } from "react";

interface NotionStyleLayoutProps {
  children: ReactNode;
}

export function NotionStyleLayout({ children }: NotionStyleLayoutProps) {
  return (
    <div className="min-h-screen bg-background">
      <div className="px-6 pb-8 pt-6">
        <div className="space-y-8">{children}</div>
      </div>
    </div>
  );
}
